import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { authService } from '../services/api';
import { getCookie, deleteCookie } from '../utils/cookies';

function AdminRoute({ children }) {
	const { user, loading, refreshUserData } = useAuth();
	const [checking, setChecking] = useState(true);
	const [hasAccess, setHasAccess] = useState(false);
	const location = useLocation();

	useEffect(() => {
		// Kiểm tra quyền admin mỗi khi chuyển màn hình
		const checkAdminAccess = async () => {
			const token = getCookie('token');

			if (!token) {
				setHasAccess(false);
				setChecking(false);
				return;
			}

			try {
				// Gọi API who-am-i để kiểm tra quyền
				const response = await authService.whoAmI();

				if (response.success && response.data && response.data.role === 'admin') {
					setHasAccess(true);
					// Lưu thông tin user vào localStorage
					localStorage.setItem('user', JSON.stringify(response.data));
				} else {
					setHasAccess(false);
				}
			} catch (error) {
				console.error('Admin access check failed:', error);
				setHasAccess(false);
				// Xóa token nếu không hợp lệ
				deleteCookie('token');
				deleteCookie('refreshToken');
				localStorage.removeItem('user');
			} finally {
				setChecking(false);
			}
		};

		checkAdminAccess();
	}, [location.pathname]);

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100vh"
			>
				<CircularProgress />
			</Box>
		);
	}

	// Đợi kiểm tra quyền truy cập
	if (checking) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100vh"
			>
				<CircularProgress />
			</Box>
		);
	}

	// Check if user is logged in and is admin
	if (!user || user.role !== 'admin' || !hasAccess) {
		return <Navigate to="/login" replace />;
	}

	return children;
}

export default AdminRoute;
